export function isCallable(input: unknown): input is Function {
  return typeof input === 'function';
}
